import { HTMLAttributes } from "react";
import { cn } from "../../lib/cn";

type AlertVariant = "success" | "error" | "warning" | "info";

const variantClasses: Record<AlertVariant, string> = {
  success: "border-green-200 bg-status-success-bg text-status-success",
  error: "border-red-200 bg-status-danger-bg text-status-danger",
  warning: "border-amber-200 bg-status-warning-bg text-status-warning",
  info: "border-brand-200 bg-status-info-bg text-status-info",
};

export interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  variant?: AlertVariant;
  onDismiss?: () => void;
}

export function Alert({
  className,
  variant = "info",
  onDismiss,
  children,
  ...props
}: AlertProps) {
  return (
    <div
      role="alert"
      className={cn(
        "flex items-start justify-between gap-3 rounded-lg border px-4 py-3 text-sm leading-relaxed",
        variantClasses[variant],
        className
      )}
      {...props}
    >
      <div className="flex-1">{children}</div>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="shrink-0 text-current opacity-60 transition-opacity hover:opacity-100"
          aria-label="Dismiss"
        >
          ×
        </button>
      )}
    </div>
  );
}
